import tns from 'tinyslider';

export default class Carousel {
    
    constructor(root) {
        this.container = root;

        this.sliderContainer = this.container.querySelector('.slider');
        this.dotsContainer = this.container.querySelector('.dots');
        this.countContainer = this.container.querySelector('.slide-status .slide-number');
        this.leftButton = this.container.querySelector('.slide-status .left-button');
        this.rightButton = this.container.querySelector('.slide-status .right-button');
        this.controlsContainer = this.container.querySelector('.slide-status');

        this.index = 0;

        this.slider = tns({
            container: this.sliderContainer,
            controlsContainer: this.controlsContainer,
            items: 1,
            slideBy: 1,
            center: false,
            edgePadding: 20,
            responsive: {
              769: {
                  // nav: false,
                items: 2,
                edgePadding: 75
              },
              1201: {
                edgePadding: 200
              }
            },
            freezable: false, // This is necessary to keep edgePadding intact for sliders which would otherwise fit within the viewport
            loop: false,
            autoWidth: false,
            mouseDrag: true,
            gutter: 20,
            controls: false,
            nav: true,
            navContainer: this.dotsContainer
        });

        this.slider.index = 0;

        this.canScroll = true;
        this.sliderContainer.addEventListener('wheel', e => {
            if(!this.canScroll || Math.abs(e.deltaX) < 10) {
                return;
            }

            this.canScroll = false;
            setTimeout(() => {
                this.canScroll = true;
            }, 500);

            let scrollDir = e.deltaX >= 1 ? 1 : -1;

            if(scrollDir > 0) {
                this.slider.goTo('next');
            } else {
                this.slider.goTo('prev');
            }
        });

        this.registerListeners();
    }

    registerListeners() {
        const instance = this;

        this.leftButton.addEventListener('click', () => {
            instance.slider.goTo('prev')
        });

        this.rightButton.addEventListener('click', () => {
            instance.slider.goTo('next')
        });

        this.slider.events.on('indexChanged', (info) => {
            if(isFinite(info.displayIndex)) {
                instance.countContainer.innerText = `${info.displayIndex}/${info.slideCount}`;
                instance.leftButton.disabled = info.displayIndex <= 1;
                instance.rightButton.disabled = info.displayIndex >= info.slideCount;
            }
        });
    }
}